import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { categoriesApi } from ".";

export const useCategory = (categoryId: number) => {
  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.CATEGORY_BY_ID(categoryId!),
    queryFn: () => categoriesApi.fetchById(categoryId),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.CATEGORY_BY_ID(categoryId) });
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.CATEGORIES });
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.CATEGORY_TREE });
  };
  return { isLoading, category: data?.data, invalidate };
};
